import React from "react";
import {
  formatCash,
  formatDate,
  processQuote,
} from "../../../../../utils/sharedFunctions";
import { TextInputDropdown, TextInput } from "../../../../../components";
import { MenuItem } from "@mui/material";
const downArrow = `${process.env.REACT_APP_CDN_URL}/globalAssets/briefview/downArrow.svg`;

const FinanceTab = ({
  IsInfoEdit,
  SelectedBrief,
  handleFeeChange,
  handleStatusChange,
  handleFulfilmentStageChange,
  handleMilestoneChange,
  handleProjectPaymentChange,
}) => {
  const isMigrated = SelectedBrief?.isMigrated === true;

  // Find the Quote Array: Can be at root, inside 'brief', or inside 'briefId'
  const validQuote =
    SelectedBrief?.brief?.quote ??
    SelectedBrief?.briefId?.quote ??
    SelectedBrief?.quote ??
    [];

  // Find the Project Plan: Can be at root, inside 'brief', or inside 'briefId'
  const validProjectPlan =
    SelectedBrief?.projectPlan ??
    SelectedBrief?.brief?.projectPlan ??
    SelectedBrief?.briefId?.projectPlan ??
    [];

  let clientFee = 0;
  if (isMigrated) {
    clientFee = SelectedBrief?.staticValues?.credippleFee ?? 0;
  } else {
    clientFee =
      validQuote?.[0]?.credippleClientFee ??
      SelectedBrief?.payments?.credippleFeeInRand ??
      0;
  }

  // B. Professional Fee (Total Payable)
  let totalPayable = 0;
  if (isMigrated) {
    totalPayable = SelectedBrief?.staticValues?.professionalFees ?? 0;
  } else {
    const quoteRaw = processQuote(SelectedBrief, SelectedBrief?.professional);
    totalPayable = quoteRaw?.totalPayable || 0;

    // Fallback: If utility returns 0, manually check the validQuote array found above
    if (totalPayable === 0) {
      totalPayable = validQuote?.[0]?.billableTotal ?? 0;
    }
  }

  const totalProjectCost = totalPayable + clientFee;

  // --------------------------------------------------------------------------

  return IsInfoEdit ? (
    <div className="BriefFinanceTabSect">
      <div
        className="financeDetailsContainer"
        style={{ alignItems: "center", justifyContent: "flex-start" }}
      >
        <span className="availFinanceDetailsSect">
          <p className="header">Total Project Cost</p>
          <p className="value">ZAR {formatCash(totalProjectCost)}</p>
        </span>
        <span className="availFinanceDetailsSect">
          <p className="header">Credipple Fee</p>
          <p className="value">ZAR {formatCash(clientFee)}</p>
        </span>
        <span className="availFinanceDetailsSect">
          <p className="header">Service Provider Fee</p>
          <p className="value">
            ZAR {formatCash(isMigrated ? totalPayable : totalPayable * 0.9)}
          </p>
        </span>
      </div>

      <div
        className="financeDetailsContainer"
        style={{ alignItems: "center", justifyContent: "flex-start" }}
      >
        <TextInputDropdown
          style={{ width: "33%", marginRight: "1%" }}
          label="Job Status"
          placeholder="Job Status"
          id="JobStatus"
          value={SelectedBrief?.briefStatus ?? SelectedBrief?.status ?? ""}
          onChange={handleStatusChange}
        >
          <MenuItem value="Not Started">Not Started</MenuItem>
          <MenuItem value="approved">approved</MenuItem>
          <MenuItem value="In Progress">In Progress</MenuItem>
          <MenuItem value="Completed">Completed</MenuItem>
          <MenuItem value="On Hold">On Hold</MenuItem>
          <MenuItem value="Cancelled">Cancelled</MenuItem>
        </TextInputDropdown>

        <TextInputDropdown
          style={{ width: "33%", marginRight: "1%" }}
          label="Fulfillment Stage"
          placeholder="Fulfillment Stage"
          value={
            isMigrated
              ? "Brief"
              : Array.isArray(validProjectPlan) &&
                  validProjectPlan[0]?.fulfillmentStage
                ? validProjectPlan[0].fulfillmentStage
                : ""
          }
          onChange={handleFulfilmentStageChange}
        >
          <MenuItem value="Brief">Brief</MenuItem>
          <MenuItem value="Quote and Project Plan">
            Quote and Project Plan
          </MenuItem>
          <MenuItem value="Deposit Invoice">Deposit Invoice</MenuItem>
          <MenuItem value="Contracting">Contracting</MenuItem>
          <MenuItem value="Project in Progress">Project in Progress</MenuItem>
          <MenuItem value="Milestone Payment">Milestone Payment</MenuItem>
          <MenuItem value="Professional Evaulation">
            Professional Evaulation
          </MenuItem>
          <MenuItem value="Final Payment">Final Payment</MenuItem>
          <MenuItem value="Project Closed">Project Closed</MenuItem>
        </TextInputDropdown>

        <TextInputDropdown
          style={{ width: "33%", marginRight: "1%" }}
          label="Payment Milestone Number"
          placeholder="Payment Milestone Number"
          value={validQuote?.[0]?.milestone ?? ""}
          onChange={handleMilestoneChange}
        >
          <MenuItem value="Milestone 1 of 1">Milestone 1 of 1</MenuItem>
          <MenuItem value="Milestone 1 of 2">Milestone 1 of 2</MenuItem>
          <MenuItem value="Milestone 2 of 2">Milestone 2 of 2</MenuItem>
          <MenuItem value="Milestone 1 of 3">Milestone 1 of 3</MenuItem>
          <MenuItem value="Milestone 2 of 3">Milestone 2 of 3</MenuItem>
          <MenuItem value="Milestone 3 of 3">Milestone 3 of 3</MenuItem>
          <MenuItem value="Monthly Retainer">Monthly Retainer</MenuItem>
        </TextInputDropdown>
      </div>

      <div className="projectPaymentsSection">
        <p className="header">Project Payments</p>
        <div className="invoiceSection">
          <div className="invoiceheaderSect">
            <p style={{ width: "20%" }}>Invoice Number</p>
            <p style={{ width: "20%" }}>Date</p>
            <p style={{ width: "20%" }}>Payment Method</p>
            <p style={{ width: "20%" }}>PO Number</p>
            <p style={{ width: "20%" }}>Voucher Code</p>
            <p style={{ width: "20%" }}>Amount</p>
          </div>
          <div className="availInvoiceContainer">
            {isMigrated ? (
              <div className="availCard">
                <TextInput
                  value={SelectedBrief?.staticValues?.invoiceNumber || ""}
                  style={{ width: "16.67%" }}
                  disabled
                />
                <TextInput
                  value={formatDate(SelectedBrief?.createdAt)}
                  style={{ width: "16.67%" }}
                  disabled
                />
                <p style={{ width: "16.67%" }}>N/A</p>
                <TextInput
                  value={SelectedBrief?.staticValues?.purchaseOrder || ""}
                  style={{ width: "16.67%" }}
                  disabled
                />
                <TextInput
                  value={SelectedBrief?.staticValues?.voucherID || ""}
                  style={{ width: "16.67%" }}
                  disabled
                />
                <TextInput
                  value={formatCash(
                    SelectedBrief?.staticValues?.jobAmount || 0
                  )}
                  style={{ width: "16.67%" }}
                  disabled
                />
              </div>
            ) : (
              SelectedBrief?.payments?.invoiceNumbers?.map((item, index) => (
                <div className="availCard" key={index}>
                  <TextInput
                    value={item || ""}
                    id="invoice"
                    key={index}
                    placeholder={"TYC0456"}
                    style={{ width: "16.67%" }}
                    onChange={(e) => handleProjectPaymentChange(e, index)}
                  />
                  <TextInput
                    type="date"
                    value={
                      SelectedBrief?.payments?.previousPayments?.[index]
                        ?.date ?? ""
                    }
                    id="date"
                    style={{ width: "16.67%" }}
                    onChange={(e) => handleProjectPaymentChange(e, index)}
                  />
                  <p style={{ width: "16.67%" }}>
                    {SelectedBrief.paymentMethod ?? ""}
                  </p>
                  <TextInput
                    value={SelectedBrief?.payments?.purchaseOrderNumber ?? ""}
                    id="poNumber"
                    style={{ width: "16.67%" }}
                    onChange={(e) => handleProjectPaymentChange(e, index)}
                  />
                  <TextInput
                    value={SelectedBrief.payments?.voucherId ?? ""}
                    id="voucher"
                    style={{ width: "16.67%" }}
                    onChange={(e) => handleProjectPaymentChange(e, index)}
                  />
                  <TextInput
                    value={
                      SelectedBrief?.payments?.previousPayments?.[index]
                        ?.amount ?? 0
                    }
                    id="amnt"
                    style={{ width: "16.67%" }}
                    onChange={(e) => handleProjectPaymentChange(e, index)}
                  />
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="BriefFinanceTabSect">
      <div className="financeDetailsContainer">
        <span className="availFinanceDetailsSect">
          <p className="header">Total Project Cost</p>
          <p className="value">ZAR {formatCash(totalProjectCost)}</p>
        </span>
        <span className="availFinanceDetailsSect">
          <p className="header">Credipple Fee</p>
          <p className="value">ZAR {formatCash(clientFee)}</p>
        </span>
        <span className="availFinanceDetailsSect">
          <p className="header">Service Provider Fee</p>
          <p className="value">
            ZAR {formatCash(isMigrated ? totalPayable : totalPayable * 0.9)}
          </p>
        </span>
      </div>

      <div className="financeDetailsContainer">
        <span className="availFinanceDetailsSect">
          <p className="header">Job Status</p>
          <div className="briefStageSect">
            <p>
              {SelectedBrief?.briefStatus || SelectedBrief?.status || "N/A"}
            </p>
            <img src={downArrow} alt="" />
          </div>
        </span>
        <span className="availFinanceDetailsSect">
          <p className="header">Fulfillment Stage</p>
          <div className="briefStageSect">
            <p>
              {isMigrated
                ? "Brief"
                : Array.isArray(validProjectPlan) &&
                    validProjectPlan[0]?.fulfillmentStage
                  ? validProjectPlan[0].fulfillmentStage
                  : "Not Assigned"}
            </p>
            <img src={downArrow} alt="" />
          </div>
        </span>
        <span className="availFinanceDetailsSect">
          <p className="header">Payment Milestone</p>
          <div className="briefStageSect">
            <p>{validQuote?.[0]?.milestone || "N/A"}</p>
            <img src={downArrow} alt="" />
          </div>
        </span>
      </div>

      <div className="projectPaymentsSection">
        <p className="header">Project Payments</p>

        {isMigrated ? (
          <div className="invoiceSection">
            <div className="invoiceheaderSect">
              <p style={{ width: "16.67%" }}>Invoice Number</p>
              <p style={{ width: "16.67%" }}>Date</p>
              <p style={{ width: "16.67%" }}>Payment Method</p>
              <p style={{ width: "16.67%" }}>PO Number</p>
              <p style={{ width: "16.67%" }}>Voucher Code</p>
              <p style={{ width: "16.67%" }}>Amount</p>
            </div>
            <div className="availInvoiceContainer">
              <div className="availCard">
                <p style={{ width: "16.67%" }}>
                  {SelectedBrief?.staticValues?.invoiceNumber || "N/A"}
                </p>
                <p style={{ width: "16.67%" }}>
                  {formatDate(SelectedBrief?.createdAt)}
                </p>
                <p style={{ width: "16.67%" }}>N/A</p>
                <p style={{ width: "16.67%" }}>
                  {SelectedBrief?.staticValues?.purchaseOrder || "N/A"}
                </p>
                <p style={{ width: "16.67%" }}>
                  {SelectedBrief?.staticValues?.voucherID || "N/A"}
                </p>
                <p style={{ width: "16.67%" }}>
                  ZAR {formatCash(SelectedBrief?.staticValues?.jobAmount || 0)}
                </p>
              </div>
            </div>
          </div>
        ) : SelectedBrief?.payments ? (
          <div className="invoiceSection">
            <div className="invoiceheaderSect">
              <p style={{ width: "16.67%" }}>Invoice Number</p>
              <p style={{ width: "16.67%" }}>Date</p>
              <p style={{ width: "16.67%" }}>Payment Method</p>
              <p style={{ width: "16.67%" }}>PO Number</p>
              <p style={{ width: "16.67%" }}>Voucher Code</p>
              <p style={{ width: "16.67%" }}>Amount</p>
            </div>
            <div className="availInvoiceContainer">
              {Array.isArray(SelectedBrief?.payments?.invoiceNumbers) &&
              SelectedBrief.payments.invoiceNumbers.some(
                (i) => i && i !== ""
              ) ? (
                SelectedBrief.payments.invoiceNumbers.map((item, index) => {
                  // Only render if item exists
                  if (!item && item !== 0) return null;
                  return (
                    <div className="availCard" key={index}>
                      <p style={{ width: "16.67%" }}>{item}</p>
                      <p style={{ width: "16.67%" }}>
                        {formatDate(
                          SelectedBrief?.payments?.previousPayments?.[index]
                            ?.date
                        )}
                      </p>
                      <p style={{ width: "16.67%" }}>
                        {SelectedBrief?.paymentMethod || "EFT"}
                      </p>
                      <p style={{ width: "16.67%" }}>
                        {SelectedBrief.payments.purchaseOrderNumber ?? ""}
                      </p>
                      <p style={{ width: "16.67%" }}>
                        {SelectedBrief.payments?.voucherId ?? ""}
                      </p>
                      <p style={{ width: "16.67%" }}>
                        ZAR{" "}
                        {formatCash(
                          SelectedBrief?.payments?.previousPayments?.[index]
                            ?.amount || 0
                        )}
                      </p>
                    </div>
                  );
                })
              ) : (
                <p className="noDataMsg">No Payments Data Available</p>
              )}
            </div>
          </div>
        ) : (
          <div className="noDataContainer">
            <p className="noDataMsg">No Payments Data Available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinanceTab;
